import { List, Record } from 'immutable';
import { schema } from 'normalizr';

export const RelayLoad = new Record({
  id: undefined,
  name: 'NO NAME RELAYLOAD',
  description: '',
  number_of_fixtures: undefined,
  direction: undefined,
  primary_relay: undefined,
  fixture: undefined,
  schedules: new List(),
  contract: null,
});

export const relayLoadSchema = new schema.Entity('relayLoads');
